import { fields } from ".";
import Button from "components/atoms/Button";
import { modalActions } from "redux/slices/modal";
import { reduxForm } from "redux-form";
import { useAppDispatch } from "redux/hooks";
import ReduxFormFields from "components/molecules/ReduxFormFields";

function ConfirmRefundFrom({ form, handleSubmit }: any) {
  const dispatch = useAppDispatch();

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <ReduxFormFields fields={fields} />
        <br />

        <Button
          variant="outlined"
          sx={{ marginRight: "10px" }}
          onClick={() => dispatch(modalActions.closeModal())}
        >
          Cancel
        </Button>
        <Button type="submit" variant="contained">
          Submit
        </Button>
      </form>
    </div>
  );
}

export default reduxForm({ form: "ConfirmRefundFrom" })(ConfirmRefundFrom);
